module.exports = __webpack_public_path__ + "img/ziz2.b6f5fe7d.jpg";